import type { IconData } from '@stacksjs/iconify-core'

export const battery: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19 3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2zm-2 1.5V2H2v8h15z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default battery
